// extracted by mini-css-extract-plugin
export default {"root":"xo92Y","myMessage":"jmM77","firstInGroup":"MUUoX","lastInGroup":"nh2y0","avatars":"UMnMu","avatar":"TvSmt","subscribedAvatar":"P9vH0","stars":"K94QC","text":"hRxCJ"};